export default __webpack_public_path__ + "static/media/HealingForce.48b74bfd.jpg";